import * as Rx from 'rxjs';
import * as RxOp from 'rxjs/operators';
import { addToCart } from '../../utils/api/client';
import { getPosApiUrl, getAccessToken } from '../../utils/state';

import {
  ADD_TO_CART_REQUEST,
  lookupAlertBarAction,
  addToCartSuccess,
  addToCartError,
} from './Lookup.state';
import { caughtError } from '../../utils/api/errorHandler';

const caughtLookupErrorCallback = (state) =>
  caughtError(lookupAlertBarAction, '', state, false, true);

const addToCartParams = (state, payload) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
  receivables: payload.receivables,
});

export const addToCartEpic = (action$, state$) =>
  action$.ofType(ADD_TO_CART_REQUEST).pipe(
    RxOp.flatMap((action) =>
      Rx.from(addToCart(addToCartParams(state$.value, action.payload))).pipe(
        RxOp.flatMap((response) => {
          action.payload.navigate('/pos/cart');
          return Rx.of(addToCartSuccess(response.data));
        }),
        RxOp.catchError((err) =>
          caughtLookupErrorCallback(state$.value)(
            err,
            addToCartError(err.message),
          ),
        ),
      ),
    ),
  );
